<template>
  <div class="container-fluid pt-3">
    <ClientItem v-if="client" :client="client"/>

    <ClientList v-else />
  </div>
</template>

<script>
  import ClientItem from './client/Item';
  import ClientList from './client/List';

  export default {
    name: 'Client',

    components: {ClientItem, ClientList},

    data() {
      return {};
    },

    computed: {
      client: function () {
        return this.$store.state.clients.find(
          item => item.id === this.$store.state.clientId
        );
      },
    },
  };
</script>
